
import './App.css';
import { BrowserRouter } from "react-router-dom"
import Header from './Components/Header';
import Hero from './Components/Hero';
import RejuvenateServices from './Components/RejuvenateServices';
import OffersBanner from './Components/offerBanner';
import WhyRejuvenate from './Components/WhyRejuvenate';
import TransformationsSection from './Components/TransformationsSection';
import ReviewsSection from './Components/ReviewsSection';
import PortfolioSection from './Components/PortfolioSection';
import EnquiryForm from './Components/EnquiryForm';
import FindUsSection from './Components/FindUsSection';
import FooterSection from './Components/FooterSection';
function App() {
  return (
    <>
    <BrowserRouter>
    <Header/>
    <section id = "home">
     <Hero/>
    </section>
    <section id = "treatments">
    <RejuvenateServices/>
    </section>
    <OffersBanner/>
    <section id = "about">
    <WhyRejuvenate/>
    </section>
    <section id = 'offers'>
    <TransformationsSection/>
    </section>
    <section id = "reviews">
      <ReviewsSection/>
    </section>
    <section id = "results">
    <PortfolioSection/>
    </section> 
    <section id = "contact"> 
      <EnquiryForm/>
    </section>
   <section>
    <FindUsSection/>
   </section>
    <FooterSection/>
    </BrowserRouter>
    
    </>
  );
}

export default App;
